import { Button, Modal } from '@dev-spendesk/grapes';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routes, routeFor } from 'src/core/constants/routes';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';
import { fetchMe } from 'src/core/modules/app/layout/redux/actions';
import { type AppDispatch } from 'src/core/modules/app/redux/store';

import { useApprovalWorkflowQuery } from './useApprovalWorkflowQuery';

export const ApprovalByDimensionsActivationModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation('global');
  const { status } = useApprovalWorkflowQuery({ enabled: isOpen });
  const dispatch = useDispatch<AppDispatch>();
  const history = useHistory();
  const companyId = useCompanyId();

  useEffect(() => {
    const handleSuccess = async () => {
      if (status === 'success') {
        try {
          await dispatch(fetchMe());
          history.push(
            routeFor(routes.APPROVAL_WORKFLOWS.path, { company: companyId }),
          );
        } catch (error) {
          throw new Error('Failed to fetch user data:', error);
        }
      }
    };

    handleSuccess();
  }, [status, history, companyId]);

  return (
    <Modal
      iconName="arrow-path"
      actions={[
        <Button
          key="migration-modal-button"
          text={t('costCenters.activationBanner.modal.button')}
          variant="secondaryNeutral"
          onClick={onClose}
        />,
      ]}
      isOpen={isOpen}
      title={t('costCenters.activationBanner.modal.title')}
      subtitle={t('costCenters.activationBanner.modal.description')}
    />
  );
};
